// extracted by mini-css-extract-plugin
export var section = "styles-module--section--3p82b";
export var title = "styles-module--title--2Suk0";
export var list = "styles-module--list--2QtiJ";